import { render } from "./WebinarVideo.vue?vue&type=template&id=c4d80b02"
import script from "./WebinarVideo.vue?vue&type=script&lang=js"
export * from "./WebinarVideo.vue?vue&type=script&lang=js"

import "./WebinarVideo.vue?vue&type=style&index=0&id=c4d80b02&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__